import Configurator from './Configurator.svelte';

const root = document.querySelector('#digibord-configurator-root');

const configurator = new Configurator({
	target: root,
	props: {
		category: root.getAttribute('data-category'),
		description: root.getAttribute('data-description'),
		finish: root.getAttribute('data-finish'),
		title: root.getAttribute('data-title')
	}
});

export default configurator;